<template>
	<QnaRegisterReply
		:replyId="$route.params._id"
		qnaType="comment"
		@register="handleRegister"
	/>
</template>
<script>
	import QnaRegisterReply from '@/components/qna/QnaRegisterReply.vue';

	export default {
		components: {
			QnaRegisterReply,
		},
		data() {
			return {
				params: {},
			};
		},
		methods: {
			async registerReply() {
				try {
					const res = await this.$axiosAdmin2.post(
						'/api/qna/reply',
						this.params
					);
					this.$router.push('/qna/c/list');
					alert('등록되었습니다.');
				} catch (error) {
					console.error('error');
					alert(
						'등록에 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
				}
			},
			handleRegister(params) {
				this.params = params;
				this.registerReply();
			},
		},
	};
</script>
<style lang="scss" scoped></style>
